import React from "react";
import { Card, ProgressBar } from "react-bootstrap";

export default function WorkingHoursCard() {
  return (
    <>
      <Card className="working-hours-card h-100 border-0">
        <Card.Body>
          {/* TOP STATS */}
          <div className="row stats-row">
            <div className="col-xl-3 col-lg-6 col-md-6 col-6 stat-item">
              <p className="label">
                <span className="dot grey"></span>
                Total Working hours
              </p>

              <h3>12h 36m</h3>
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6 col-6 stat-item">
              <p className="label">
                <span className="dot green"></span>
                Productive Hours
              </p>

              <h3>08h 36m</h3>
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6 col-6 stat-item">
              <p className="label">
                <span className="dot yellow"></span>
                Break hours
              </p>

              <h3>22m 15s</h3>
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6 col-6 stat-item">
              <p className="label">
                <span className="dot blue"></span>
                Overtime
              </p>

              <h3>02h 15m</h3>
            </div>
          </div>

          {/* PROGRESS BAR */}
          <div className="timeline-wrapper">
            <ProgressBar className="timeline-bar">
              <ProgressBar now={18} variant="success" key={1} />
              <ProgressBar now={10} variant="warning" key={2} />
              <ProgressBar now={28} variant="success" key={3} />
              <ProgressBar now={17} variant="warning" key={4} />
              <ProgressBar now={22} variant="success" key={5} />
              <ProgressBar now={5} variant="info" key={6} />
            </ProgressBar>

            {/* TIME */}
            <div className="timeline-time">
              {[
                "06:00",
                "07:00",
                "08:00",
                "09:00",
                "10:00",
                "11:00",
                "12:00",
                "01:00",
                "02:00",
                "03:00",
                "04:00",
                "05:00",
                "06:00",
                "07:00",
                "08:00",
                "09:00",
                "10:00",
                "11:00",
              ].map((t, i) => (
                <span key={i}>{t}</span>
              ))}
            </div>
          </div>
        </Card.Body>
      </Card>

      <style>{`
      
.working-hours-card {
  margin-top: 20px;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.04);
  overflow: hidden;
}

.stats-row {
  row-gap: 20px;
  margin-bottom: 28px;
}

.stat-item h3 {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.label {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.dot {
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 50%;
  flex-shrink: 0;
}

.grey {
  background: #cfcfcf;
}

.green {
  background: #19b15f;
}

.yellow {
  background: #f4b400;
}

.blue {
  background: #2f80ed;
}

.timeline-wrapper {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: none;
}

.timeline-wrapper::-webkit-scrollbar {
  display: none;
}

.timeline-bar {
  height: 18px;
  min-width: 1000px;
  background: #f3f4f6;
  border-radius: 30px;
  overflow: hidden;
  margin-bottom: 14px;
}

.timeline-bar .progress-bar {
  border-radius: 0 !important;
}

.timeline-time {
  min-width: 1000px;
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #6b7280;
  padding: 0 2px;
}

.timeline-time span {
  white-space: nowrap;
}

/* MOBILE RESPONSIVE */

@media (max-width: 991px) {

  .stat-item h3 {
    font-size: 22px;
  }

  .label {
    font-size: 13px;
  }
}

@media (max-width: 767px) {

  .working-hours-card {
    border-radius: 10px;
  }

  .stats-row {
    row-gap: 18px;
    margin-bottom: 20px;
  }

  .stat-item {
    text-align: left;
  }

  .stat-item h3 {
    font-size: 18px;
  }

  .label {
    font-size: 12px;
    line-height: 18px;
  }

  .timeline-bar {
    height: 14px;
  }

  .timeline-time {
    font-size: 10px;
  }
}

@media (max-width: 480px) {

  .stat-item h3 {
    font-size: 16px;
  }

  .label {
    font-size: 11px;
  }
}

      `}</style>
    </>
  );
}